import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Image as ImageIcon } from 'lucide-react';
export function Haircuts() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="pt-32 pb-24 bg-white min-h-screen" data-id="element-527">
      <div className="container mx-auto px-6 md:px-12" data-id="element-528">
        {/* HERO SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto text-center mb-20" data-id="element-529">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-ink mb-6" data-id="element-530">
            Стрижки
          </h1>
          <p className="text-muted text-lg md:text-xl font-normal leading-relaxed" data-id="element-531">
            Чоловічі, жіночі та дитячі стрижки будь-якої складності — від
            класичних до модельних.
          </p>
        </motion.div>

        {/* PRICE TABLE SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="max-w-4xl mx-auto mb-24" data-id="element-532">
          <div className="text-center mb-12" data-id="element-533">
            <h2 className="font-heading text-3xl font-semibold text-ink mb-4" data-id="element-534">
              Прайс
            </h2>
            <div className="w-12 h-1 bg-ink mx-auto rounded-full" data-id="element-535"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-536">
            {/* TAB 1 */}
            <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-537">
              <h3 className="text-xl font-semibold text-ink mb-6 pb-4 border-b border-line" data-id="element-538">
                Жіночі стрижки
              </h3>
              <ul className="space-y-4" data-id="element-539">
                {[{
                name: 'Проста коротка',
                price: '200 грн'
              }, {
                name: 'Шапочка',
                price: '200–250 грн'
              }, {
                name: 'Каскад',
                price: '250–400 грн'
              }, {
                name: 'Каре / Боб-каре',
                price: '250–350 грн'
              }, {
                name: 'Модельні',
                price: '300–350 грн'
              }, {
                name: 'Чілка',
                price: '50–70 грн'
              }, {
                name: 'Миття волосся',
                price: '50–70 грн'
              }].map((item, i) => <li key={i} className="flex justify-between items-center text-base" data-id="element-540">
                    <span className="text-muted" data-id="element-541">{item.name}</span>
                    <span className="font-semibold text-ink" data-id="element-542">{item.price}</span>
                  </li>)}
              </ul>
            </div>

            {/* TAB 2 */}
            <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-543">
              <h3 className="text-xl font-semibold text-ink mb-6 pb-4 border-b border-line" data-id="element-544">
                Чоловічі стрижки
              </h3>
              <ul className="space-y-4" data-id="element-545">
                {[{
                name: 'Під нуль',
                price: '100 грн'
              }, {
                name: 'Одна насадка',
                price: '150 грн'
              }, {
                name: '2–3 насадки',
                price: '200–250 грн'
              }, {
                name: 'Машинка + ножиці',
                price: '250–300 грн'
              }, {
                name: 'Модельна',
                price: '300–350 грн'
              }, {
                name: 'Борода',
                price: '70–100 грн'
              }, {
                name: 'Миття',
                price: '50 грн'
              }].map((item, i) => <li key={i} className="flex justify-between items-center text-base" data-id="element-546">
                    <span className="text-muted" data-id="element-547">{item.name}</span>
                    <span className="font-semibold text-ink" data-id="element-548">{item.price}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>

        {/* PORTFOLIO SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-24" data-id="element-549">
          <div className="text-center mb-12" data-id="element-550">
            <h2 className="font-heading text-3xl font-semibold text-ink mb-4" data-id="element-551">
              Мої роботи
            </h2>
            <div className="w-12 h-1 bg-ink mx-auto rounded-full" data-id="element-552"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-553">
            {[1, 2, 3].map(i => <div key={i} className="aspect-[3/4] bg-surface rounded-[2rem] border border-line flex items-center justify-center shadow-sm" data-id="element-554">
                <div className="text-center flex flex-col items-center" data-id="element-555">
                  <ImageIcon className="text-muted mb-3" size={32} strokeWidth={1.5} data-id="element-556" />
                  <p className="text-xs text-muted font-medium tracking-widest uppercase" data-id="element-557">
                    Фото роботи
                  </p>
                </div>
              </div>)}
          </div>
        </motion.div>

        {/* CTA SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="max-w-md mx-auto flex flex-col gap-4" data-id="element-558">
          <a href="/#contact" className="w-full py-4 bg-ink text-white text-center text-sm font-medium tracking-wide rounded-full hover:bg-black transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-559">
            Записатися
          </a>
          <Link to="/#services" className="w-full py-4 border border-line text-ink text-center text-sm font-medium tracking-wide rounded-full hover:bg-surface transition-all duration-300" data-id="element-560">
            Повернутися до послуг
          </Link>
        </motion.div>
      </div>
    </main>;
}